
import {
    CATEGORY_VARIANT_VALUE_REQUEST,
    CATEGORY_VARIANT_VALUE_SUCCESS,
    CATEGORY_VARIANT_VALUE_FAILURE, } from "../actions/actionTypes";

  const initialState = {
    categoryVariantValue: [],
    loading: false,
    error: null,
  };

  const categoryVariantValueReducer = (state = initialState, action) => {
    switch (action.type) {
      case CATEGORY_VARIANT_VALUE_REQUEST:
        return { ...state, loading: true, error: null };

      case CATEGORY_VARIANT_VALUE_SUCCESS:
        return { ...state, loading: false, categoryVariantValue: action.payload };

      case CATEGORY_VARIANT_VALUE_FAILURE:
        return { ...state, loading: false, error: action.payload };

      default:
        return state;
    }
  };

  export default categoryVariantValueReducer;
